export default "__VITE_ASSET__34324a2c__"